import { useShouldShowDevTeamFeature } from './_base';

export const useHomePageFeature: () => boolean = useShouldShowDevTeamFeature;
